class ScrollTo {
    constructor() {
        this.build();
    }
    build() {
        const attrName = 'data-scroll-to';

        Array.from(
			document.querySelectorAll('[' + attrName + ']') || []
		).forEach((element) =>
			element.addEventListener('click', (e) => {
				e.preventDefault();
				this.scrollTo(e.currentTarget.getAttribute(attrName));
			})
		);
    }
    scrollTo(attrs) {
        const attribute = attrs.split(',');

		let y = attribute[0].trim();
		let offset = attribute[1] ? attribute[1].trim() : 0;

		if (!this._isNum(y)) {
			let targetElement;

			if (typeof y === 'string') {
				targetElement = document.querySelector(y);

                // If no element jump out
                if (!targetElement) {
                    console.error('No element found on the page');
                    return;
                }
			}
            else {
				targetElement = y;
			}

			y = targetElement.getBoundingClientRect().top + (window.pageYOffset || document.body.scrollTop);
		}

        y = y + offset;

		y = y < 0 ? 0 : y;

        // Scroll to element
        window.scroll({
            top: y
        });
	}
    _isNum(val){
        return !isNaN(val);
    }
}

export default new ScrollTo();
